"use client";

import Lottie from "react-lottie";
import lottieSiteLoader from "utils/lottie/thinking.json";

const loaderLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: lottieSiteLoader,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

interface IAiThinker {
  size: number;
  height?: number;
}

const AiThinker = (props: IAiThinker) => {
  const { size, height } = props;

  return (
    <Lottie
      isClickToPauseDisabled
      options={loaderLottieOptions}
      height={height || size}
      width={size}
    />
  );
};

export default AiThinker;
